// ENABLE USERS //
export const USERS_ENABLED = true;
// SERVER ADDRESS //
// Chosen by the build, never by hand: `npm start` and the tests talk to a backend on this
// machine, and `npm run build` always talks to the live server. A production bundle that
// pointed at localhost would take every calculator offline for its users.
let local = (process.env.NODE_ENV !== 'production');
export let server_url;
if(local){
    server_url = "http://localhost:8080";
}else{
    server_url = "https://toricaligner.com:8443";
}
